const SITE_URL = "https://o2-lifecenter.com";
const SITE_NAME = "Life Center";
const DEFAULT_IMAGE = `${SITE_URL}/logo.png`;

const seoConfig = {
  home: {
    title: "Life Center | Ginásio, Fisioterapia e Bem-Estar em Lisboa",
    description:
      "Centro de excelência em saúde, exercício e bem-estar em Lisboa. Ginásio, fisioterapia, nutrição, estética e triathlon coaching com profissionais certificados.",
    keywords:
      "ginásio Lisboa, ginásio Alvalade, fisioterapia Lisboa, bem-estar, saúde, exercício, Life Center",
    path: "/",
  },
  about: {
    title: "Sobre Nós | Life Center Lisboa",
    description:
      "Conheça o Life Center: desde 2015 a promover a saúde através do exercício em Lisboa. Equipa multidisciplinar dedicada à prevenção e ao bem-estar.",
    keywords:
      "sobre Life Center, equipa Life Center, ginásio Lisboa, missão saúde",
    path: "/sobre-nos",
  },
  modalidades: {
    title: "Modalidades | TRX, Pilates, Kettlebell e Personal Training",
    description:
      "Descubra as modalidades do Life Center em Lisboa: TRX, Power Circuit, Kettlebell, Pilates em grupo e treino personalizado. Packs adaptados a todos os objetivos.",
    keywords:
      "modalidades ginásio, TRX Lisboa, Pilates Lisboa, kettlebell, treino personalizado, personal trainer Lisboa",
    path: "/modalidades",
  },
  triathlon: {
    title: "Triathlon Coaching | Planos Personalizados | Life Center",
    description:
      "Triathlon coaching especializado em Lisboa: planos para Sprint, Olímpico, Ironman 70.3 e Maratona. Acompanhamento contínuo com treinador certificado.",
    keywords:
      "triathlon coaching, treinador triathlon Lisboa, plano ironman, plano maratona, Bruno Brito",
    path: "/triathlon-coaching",
  },
  terapias: {
    title: "Terapias e Clínica | Fisioterapia e Osteopatia | Life Center",
    description:
      "Clínica e terapias em Lisboa: Fisioterapia, Osteopatia, Nutrição Funcional, Pilates Clínico, Massagens e Drenagem Linfática com profissionais certificados.",
    keywords:
      "fisioterapia Lisboa, osteopatia Lisboa, nutrição funcional, drenagem linfática, pilates clínico, massagem desportiva",
    path: "/terapias",
  },
  estetica: {
    title: "Estética e Medicina Estética em Lisboa | Life Center",
    description:
      "Tratamentos de estética e medicina estética em Lisboa: harmonização facial, ácido hialurónico, peelings, HIFU, radiofrequência, drenagem linfática e mais.",
    keywords:
      "medicina estética Lisboa, estética facial, harmonização facial, ácido hialurónico, HIFU, tratamentos corporais",
    path: "/estetica",
  },
  clientes: {
    title: "Clientes Empresariais | Saúde Corporativa | Life Center",
    description:
      "Programas de saúde e bem-estar para empresas em Lisboa: ginástica laboral, chair massage, núcleos de corrida e workshops para colaboradores.",
    keywords:
      "saúde corporativa, ginástica laboral, bem-estar empresas, chair massage, programas empresariais",
    path: "/clientes-empresariais",
  },
  contactos: {
    title: "Contactos | Life Center Lisboa | Avenida de Pádua",
    description:
      "Contacte o Life Center em Lisboa. Avenida de Pádua nº 10 L, 1800-297 Lisboa. Tel: 218 531 900 | Tlm: 962 281 179 | info@o2-lifecenter.com",
    keywords:
      "Life Center contactos, ginásio Avenida de Pádua, ginásio Alvalade, contactar Life Center",
    path: "/contactos",
  },
  treinos: {
    title: "Treinos Virtuais | Life Center",
    description:
      "Treinos para fazer em casa. Confira a nossa seleção de vídeos e aceda ao canal de YouTube do Life Center.",
    keywords: "treinos em casa, treinos virtuais, exercício casa",
    path: "/treinos-virtuais",
    noindex: true,
  },
  notFound: {
    title: "Página não encontrada | Life Center",
    description: "A página que procura não existe.",
    noindex: true,
  },
};

export { seoConfig, SITE_URL, SITE_NAME, DEFAULT_IMAGE };
export default seoConfig;
